import offersService from "@/services/offersService";

const state = () => ({
  all: [],
  single: null,
  selectedOffers: []
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      await offersService.create(formData);
      dispatch(
        "common/showSuccess",
        "Angebot wurde erfolgreich gespeichert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Angebot konnte nicht gespeichert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async createMultiple({ dispatch }, formData) {
    try {
      await offersService.createMultiple(formData);
      dispatch(
        "common/showSuccess",
        "Angebote wurde erfolgreich erstellt und gespeichert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Angebote konnten nicht erstellt und gespeichert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }, formData) {
    try {
      const res = await offersService.findAll(formData);
      commit("setAll", res.data);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Angebote für diese Buchung konnten nicht geladen werden." + error,
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async getAttachement({ dispatch }, formData) {
    try {
      const res = await offersService.getAttachement(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Angebot-PDF für diese Buchung konnte nicht geladen werden." + error,
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await offersService.delete({ id });
      dispatch(
        "common/showSuccess",
        "Angebot wurde erfolgreich gelöscht.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Angebot für diese Buchung konnte nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async search({ dispatch }, payload) {
    try {
      const res = await offersService.search(payload);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Angebote konnten nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
  addSelectedOffer(state, offer) {
    state.selectedOffers.push(offer);
  },
  removeSelectedOffer(state, idx) {
    state.selectedOffers.splice(idx, 1);
  },
  resetSelectedOffers(state) {
    state.selectedOffers = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
